import React from 'react'
import Email from '../components/chatbot/Email'

function ChatbotEmail() {
  return (
    <Email />
  )
}

export default ChatbotEmail